<p-menu [model]="menuItems" class="ui-g-12" *ngIf="!menuLoading"></p-menu>